import React, { use, useCallback, useEffect, useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { Document, Page, pdfjs } from "react-pdf";
import pdfFile from "../../src/MK_Metal.pdf";

import "react-pdf/dist/Page/TextLayer.css";
import styled from "styled-components";
import { useMediaQuery } from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  mobileCurrentPage,
  pageState,
  pdfPage,
  pdfRef,
  scaleValue,
} from "../atoms";
import { useControls } from "react-zoom-pan-pinch";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const PageBox = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 1px 5px 10px rgba(0, 0, 0, 0.1);
`;
const Pages = React.forwardRef((props, ref) => {
  return (
    <PageBox className="pages" ref={ref}>
      <div>{props.children}</div>
    </PageBox>
  );
});

Pages.displayName = "Pages";

function Flipbook() {
  const [numPages, setNumPages] = useRecoilState(pdfPage);
  const pageFlipRef = useRef();
  const setPageState = useSetRecoilState(pageState);
  const [bookRef, setBookRef] = useRecoilState(pdfRef);
  const { centerView } = useControls();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [mobilePage, setMobilePage] = useRecoilState(mobileCurrentPage);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const onFlip = (e) => {
    const currentPage = e.data + 1;
    const totalPages = pageFlipRef.current.pageFlip().getPageCount(); // 전체 페이지 수
    setPageState({ currentPage, totalPages });
  };

  useEffect(() => {
    setTimeout(() => {
      centerView(1, 100, "easeOut");
    }, 100);
  }, []);

  useEffect(() => {
    setBookRef(pageFlipRef.current);
  }, []);

  return (
    <HTMLFlipBook
      width={595}
      height={841}
      showCover={true}
      flippingTime={500}
      ref={pageFlipRef} // 참조 연결
      onFlip={onFlip}
    >
      {[...Array(numPages).keys()].map((pg) => (
        <Pages key={pg + 1} number={pg + 1}>
          <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
            <Page
              pageNumber={pg + 1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Document>
        </Pages>
      ))}
    </HTMLFlipBook>
  );
}

export default Flipbook;
